import { vehicleConstants } from "../actions/constants/vehicleConstants";

export const getVehicleReducer = (state = {}, action: any) => {
  switch (action.type) {
    case vehicleConstants.getVehicleRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case vehicleConstants.getVehicleSuccess:
      return { isLoading: false, isSuccess: true, isError: false, vehicledata: action.payload };
    case vehicleConstants.getVehicleFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};

export const createVehicleReducer = (state = {}, action: any) => {
  switch (action.type) {
    case vehicleConstants.vehicleCreateRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case vehicleConstants.vehicleCreateSuccess:
      return { isLoading: false, isSuccess: true, isError: false, vehicledata: action.payload };
    case vehicleConstants.vehicleCreateFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};

export const getVehicleParamsReducer = (state = {}, action: any) => {
  switch (action.type) {
    case vehicleConstants.getVehicleParamsRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case vehicleConstants.getVehicleParamsSuccess:
      return { isLoading: false, isSuccess: true, isError: false, vehicledata: action.payload };
    case vehicleConstants.getVehicleParamsFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};

export const deleteVehicleReducer = (state = {}, action: any) => {
  switch (action.type) {
    case vehicleConstants.vehicleDeleteRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case vehicleConstants.vehicleDeleteSuccess:
      return { isLoading: false, isSuccess: true, isError: false, vehicledelete: action.payload };
    case vehicleConstants.vehicleDeleteFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};

export const toggleVehicleReducer = (state = {}, action: any) => {
  switch (action.type) {
    case vehicleConstants.vehicleToggleRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case vehicleConstants.vehicleToggleSuccess:
      return { isLoading: false, isSuccess: true, isError: false, vehicledata: action.payload };
    case vehicleConstants.vehicleToggleFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};

export const vehicleViewReducer = (state = {}, action: any) => {
  switch (action.type) {
    case vehicleConstants.vehicleViewRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case vehicleConstants.vehicleViewSuccess:
      return { isLoading: false, isSuccess: true, isError: false, vehicle: action.payload };
    case vehicleConstants.vehicleViewFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};

export const uploadVehicleReducer = (state = {}, action: any) => {
  switch (action.type) {
    case vehicleConstants.vehicleUploadRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case vehicleConstants.vehicleUploadSuccess:
      return { isLoading: false, isSuccess: true, isError: false, upload: action.payload };
    case vehicleConstants.vehicleUploadFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};

export const tripSheetSaveReducer = (state = {}, action: any) => {
  switch (action.type) {
    case vehicleConstants.tripSheetSaveRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case vehicleConstants.tripSheetSaveSuccess:
      return { isLoading: false, isSuccess: true, isError: false, data: action.payload };
    case vehicleConstants.tripSheetSaveFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};

export const tripSheetListReducer = (state = {}, action: any) => {
  switch (action.type) {
    case vehicleConstants.tripSheetListRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case vehicleConstants.tripSheetListSuccess:
      return { isLoading: false, isSuccess: true, isError: false, data: action.payload };
    case vehicleConstants.tripSheetListFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};

export const tripSheetViewReducer = (state = {}, action: any) => {
  switch (action.type) {
    case vehicleConstants.tripSheetViewRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case vehicleConstants.tripSheetViewSuccess:
      return { isLoading: false, isSuccess: true, isError: false, data: action.payload };
    case vehicleConstants.tripSheetViewFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};

export const tripSheetDeleteReducer = (state = {}, action: any) => {
  switch (action.type) {
    case vehicleConstants.tripSheetDeleteRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case vehicleConstants.tripSheetDeleteSuccess:
      return { isLoading: false, isSuccess: true, isError: false, data: action.payload };
    case vehicleConstants.tripSheetDeleteFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};

export const tripSheetByVehicleReducer = (state = {}, action: any) => {
  switch (action.type) {
    case vehicleConstants.tripSheetByVehicleRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case vehicleConstants.tripSheetByVehicleSuccess:
      return { isLoading: false, isSuccess: true, isError: false, data: action.payload };
    case vehicleConstants.tripSheetByVehicleFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};

export const tripSheetByBatchReducer = (state = {}, action: any) => {
  switch (action.type) {
    case vehicleConstants.tripSheetByBatchRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case vehicleConstants.tripSheetByBatchSuccess:
      return { isLoading: false, isSuccess: true, isError: false, data: action.payload };
    case vehicleConstants.tripSheetByBatchFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};
